import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Mongo } from 'meteor/mongo';
import { Places } from './places';
import { FlightsType } from './flights-type';
export const Prices = new Mongo.Collection('flight_prices');

Prices.allow({
	insert() { return true; },
	update() { return true; },
	remove() { return true; },
});

export const Price = new SimpleSchema({
    title: {
        type: String,
        label: "Titre"
    },
    price: {
    	type: Number,
    	label: "Prix par passager",
        decimal: true
    },
    flightId: {
    	type: String,
    	label: "Id du vol",
    	optional: true
    },
    constraintPeriod: {
        type: String,
        label: "Contrainte de période",
        allowedValues: ["Aucune restriction", "Semaine uniquement"]
    },
    constraintPlace: {
        type: String,
        label: "Contrainte de lieu",
        allowedValues: ["aucune", "anjou", "nantes"]
    },
    constraintAge: {
        type: Number,
        label: "Contrainte d'age",
		optional: true
    },
    constraintWeight: {
        type: Number,
        label: "Contraite de poids",
		optional: true
    },
    reference: {
        type: String,
        label: "Référence sur le site internet",
        optional: true
    },
    partnerId: {
    	type: String,
    	label: "Vol partenaire",
    	optional: true
    },
    createdAt: {
        type: Date,
        label: "Date de création"
    },
    editedAt: {
        type: Date,
        label: "Dernière modification",
        autoValue: function() {
          return new Date();
        }
    }
  });

Prices.attachSchema(Price);

// Dbs methods : 

Meteor.methods({
  'prices.remove'(priceId) {
    Prices.remove(priceId);
  },
  'prices.update'({_id, attributes}) {
    Prices.update(_id, { "$set": attributes }); 
  },
  'prices.insert'({attributes}) {
    Prices.insert(attributes); 
  }
});

Prices.helpers({
	flight() {
		return FlightsType.findOne(this.flightId);
	}
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/flights-type/prices.js
 **/